import './index_web.css';
import useTheme from '../../utilities/hooks/theme';
import moment from 'moment';
import Constants from '../../constants';
import React from 'react';
import Tooltip from '@mui/material/Tooltip';
import { convertToDollars } from '../../utilities/helper';

interface Props {
  item: any;
  isPoker: boolean;

  newAmount: any;
  isTransfer: any;
}

const TransactionPokerItemWeb = ({ item, isPoker, newAmount, isTransfer }: Props) => {
  const { AccountTheme: theme } = useTheme();
  const {
    balance = 0,
    createdOn = '',
    gameId = '',
    game = '',
    _id: id = '',
    entryFee = 0,
    // bonusFee = 0,
    refund = '',
    transactionType = '',
    walletType = 'Game',
    tax = 0,
    comment = null
  } = item;

  const statusColor =
    transactionType === 'debit' ? theme.transactionDebit : theme.transactionCredit;
  const col3Style = {
    background: theme.transactionHistoryDefaultCol3Bg,
    boxShadow: theme.transactionHistoryDefaultCol3BoxShadow,
    borderRight: `1px solid ${theme.transactionHistoryBorder}`
  };

  const col1Style = {
    background: theme.transactionHistoryDefaultColBg,
    boxShadow: theme.transactionHistoryDefaultColBoxShadow,
    borderRight: `1px solid ${theme.transactionHistoryBorder}`
  };
  const col2Style = {
    background: theme.transactionHistoryDefaultColBg,
    boxShadow: theme.transactionHistoryDefaultColBoxShadow,
    borderRight: `1px solid ${theme.transactionHistoryBorder}`
  };
  const col4Style = {
    background: theme.transactionHistoryDefaultColBg,
    boxShadow: theme.transactionHistoryDefaultColBoxShadow
  };
  const surfaceStyle = {
    border: `1px solid ${theme.transactionHistoryBorder}`
  };

  const detailsContainerStyle = {
    background: theme.transactionHistoryDefaultColBg,
    boxShadow: theme.transactionHistoryDefaultColBoxShadow,
    border: `1px solid ${theme.transactionHistoryBorder}`
  };

  const statusContainerStyle = {
    background: theme.transactionHistoryStatusContainerBg,
    boxShadow: theme.transactionHistoryStatusContainerBoxShadow,
    border: `2px solid ${theme.transactionHistoryBorder}`
  };
  const statusItemNameStyle = {
    background: theme.transactionHistoryStatusItemBg,
    color: theme.transactionHistoryStatusItemTextColor
  };
  return (
    <>
      <div className="transactionItem__wrapper__web" key={id}>
        <div className="transactional_poker_table_cell" style={surfaceStyle} key={id}>
          <div className="transactional_poker_table_cell_col1" style={col1Style}>
            {' '}
            {createdOn ? moment(new Date(createdOn), 'YYYY-MM-DD').format('DD-MM-YYYY') : '-'}
          </div>
          <div className="transactional_poker_table_cell_col2" style={col2Style}>
            {' '}
            {createdOn ? moment(new Date(createdOn), 'HH:mm').format('HH:mm') : '-'}
          </div>
          <div className="transactional_poker_table_cell_col3" style={col3Style}>
            {transactionType === 'debit' && (
              <p
                className="font_weight_800"
                style={{
                  color: statusColor
                }}>
                {' '}
                {isPoker ? 'Join Room / Buy In' : 'Joined Contest'}
              </p>
            )}
            {transactionType === 'credit' && (
              <p
                className="font_weight_800"
                style={{
                  color: statusColor
                }}>
                {refund
                  ? 'Got Refund'
                  : isPoker
                  ? 'Credited Back'
                  : comment
                  ? 'Winning adjustment'
                  : isTransfer
                  ? 'Transfer'
                  : 'Won Contest'}
              </p>
            )}
            <p
              style={{
                color: statusColor
              }}>{`${transactionType === 'credit' ? '+' : '-'} ${convertToDollars(newAmount)}`}</p>
          </div>
          <div className="transactional_poker_table_cell_col4" style={col4Style}>{`${
            comment ? 'Play' : walletType
          }`}</div>
        </div>
        <Tooltip
          placement="top"
          componentsProps={{
            tooltip: {
              sx: {
                backgroundColor: 'transparent'
              }
            }
          }}
          title={
            <div
              className="transactional_poker_table_status_container"
              style={statusContainerStyle}>
              <div className="transactionPokerTable__statusItem__wrapper">
                <p
                  className="transactional_poker_table_item_name"
                  style={statusItemNameStyle}>{`Game Type : `}</p>
                <p className="transactional_poker_table_item_status">{`${game}`}</p>
              </div>
              {tax > 0 && transactionType === 'credit' && (
                <div className="transactionPokerTable__statusItem__wrapper">
                  <p
                    className="transactional_poker_table_item_name"
                    style={statusItemNameStyle}>{`TDS : `}</p>
                  <p className="transactional_poker_table_item_status">{`${convertToDollars(
                    tax / 100
                  )} /-`}</p>
                </div>
              )}
              {isPoker && (
                <div className="transactionPokerTable__statusItem__wrapper">
                  <p
                    className="transactional_poker_table_item_name"
                    style={statusItemNameStyle}>{`Entry Fee : `}</p>
                  <p className="transactional_poker_table_item_status">{`${convertToDollars(
                    entryFee / 100
                  )}/-`}</p>
                </div>
              )}
              <div className="transactionPokerTable__statusItem__wrapper">
                <p
                  className="transactional_poker_table_item_name"
                  style={statusItemNameStyle}>{`Game Id : `}</p>
                <p className="transactional_poker_table_item_status">{`${gameId}`}</p>
              </div>
              <div className="transactionPokerTable__statusItem__wrapper">
                <p
                  className="transactional_poker_table_item_name"
                  style={statusItemNameStyle}>{`Transaction Id : `}</p>
                <p className="transactional_poker_table_item_status">{`${id}`}</p>
              </div>
              <div className="transactionPokerTable__statusItem__wrapper">
                <p
                  className="transactional_poker_table_item_name"
                  style={statusItemNameStyle}>{`Balance : `}</p>
                <p className="transactional_poker_table_item_status">{`${convertToDollars(
                  balance / 100
                )}/-`}</p>
              </div>
            </div>
          }>
          <div
            className="transactional_poker_table_details_container"
            style={detailsContainerStyle}>
            <Constants.Svgs.Info color={'#f2f2f2'} />
            <p>Details</p>
          </div>
        </Tooltip>
      </div>
    </>
  );
};
export default React.memo(TransactionPokerItemWeb);
